import React from 'react';
import styled, { css } from 'styled-components';
import Button from 'gatsby-theme-core/src/components/button/index';
import Options from 'gatsby-theme-vehicles/src/components/search/options';
import * as filters from 'gatsby-theme-vehicles/src/components/search/filters';
import useSearch from 'gatsby-theme-vehicles/src/components/search/hooks/use-search';
import ResultsButton from '../../../../components/search-box/results-button';

const LINK_BUTTON_TEXT = 'Of bekijk de hele voorraad';

const SearchBox = ({
  title = 'Zoek uw auto',
  hideStockPageButtonWhenWhereIsEmpty = false,
  facets,
  stockPage,
  columnWidth,
  className,
}) => {
  const { searching } = useSearch();
  return (
    <div className={className}>
      <Title>{title}</Title>
      <Form $columnWidth={columnWidth} $optionsLength={facets.length}>
        {facets.map((field) => (
          <Options
            key={field}
            {...filters[field]}
            noSpacer
            disabledWhenNoOptions
            hideWhenNoOptions={false}
            multiSelect={false}
            withCount={false}
            type="select"
            {...(field === 'size' ? { type: 'sizes' } : {})}
            title=""
          />
        ))}
      </Form>
      <StyledResultsButton />
      {!(hideStockPageButtonWhenWhereIsEmpty && !searching) && (
        <LinkButton to={stockPage.slug}>
          {LINK_BUTTON_TEXT}
        </LinkButton>
      )}
    </div>
  );
};

export const LinkButton = styled(Button).attrs({ link: true })`
  grid-area: linkButton;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const StyledResultsButton = styled(ResultsButton)`
  grid-area: resultsButton;
`;

export const Title = styled.h2`
  grid-area: title;
  display: flex;
  align-items: center;
  && {
    margin: 0;
  }
`;

export const Form = styled.div`
  grid-area: form;
  margin-top: 0.5rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
  > * {
    width: 100%;
    flex-grow: 1;
  }
  ${({ $columnWidth, $optionsLength }) => $columnWidth > 6 && $optionsLength < 4 && css`
    @media all and (min-width: ${({ theme }) => theme.breakingpoints.lg}) {
      margin-top: 0rem;
      flex-direction: row;
    }
  `}
`;

export default styled(SearchBox)`
  display: grid;
  grid-template-areas:
    "title"
    "form"
    "resultsButton"
    "linkButton";
  grid-template-rows: 1fr;
  grid-template-columns: 1fr;
  gap: 1rem;

  ${({ columnWidth }) => columnWidth > 4 && css`
    @media all and (min-width: ${({ theme }) => theme.breakingpoints.md}) {
      grid-template-columns: minmax(0, 1fr) auto;
      grid-template-areas:
        "title linkButton"
        "form form"
        "resultsButton resultsButton";
    }
  `}
  // if we are on fullWidth, and only have 1 or 2 options, show one big line
  ${({ columnWidth, facets }) => columnWidth === 12 && facets.length < 3 && css`
    @media all and (min-width: ${({ theme }) => theme.breakingpoints.xl}) {
      grid-template-columns: auto minmax(0, 1fr) auto auto;
      grid-template-areas:
        "title form resultsButton linkButton";
    }
  `}
  ${({ columnWidth, facets }) => columnWidth === 12 && facets.length > 3 && css`
    @media all and (min-width: ${({ theme }) => theme.breakingpoints.xl}) {
      grid-template-columns: 1fr 1fr 2fr;

      grid-template-areas:
        "title title form"
        "resultsButton linkButton form";

      ${Title} {
        align-items: baseline;
      }
    }

    @media all and (min-width: ${({ theme }) => theme.breakingpoints.md}) {
      ${Form} {
        display: grid;
        grid-template-columns: 1fr 1fr;
        gap: .5rem;
      }
    }
  `}
`;
